import { render, staticRenderFns } from "./select-dep-tag.vue?vue&type=template&id=878017b4&scoped=true"
import script from "./select-dep-tag.vue?vue&type=script&lang=js"
export * from "./select-dep-tag.vue?vue&type=script&lang=js"
import style0 from "./select-dep-tag.vue?vue&type=style&index=0&id=878017b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878017b4",
  null
  
)

export default component.exports